import Shared from '../shared.module.css';
import React, { useState, useEffect } from 'react';
import { IoPricetagOutline } from 'react-icons/io5';
import { collection, getFirestore, onSnapshot, query, where } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import CouponMake, { CouponEditing } from './make/index';
import CouponCard from './Card';
import Setting from '../../8.setting/index';

// 元 11.coupon/index.tsx から移動。Firestore取得ロジックは変更していない
// (couponsコレクションをcompanyIdで絞り込み、time降順で並べる)。
const CouponTab: React.FC = () => {

  const company = useAppSelector((state) => state.company.company);

  const [ couponList, setCouponList ] = useState<any[]>([]);
  const [ make, setMake ] = useState(false);
  // 「編集する」で開いているクーポン
  const [ editing, setEditing ] = useState<CouponEditing | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const db = getFirestore();
    const queryRef = query(
      collection(db, 'coupons'),
      where('companyId', '==', company.id)
    );

    const unsub = onSnapshot(queryRef, (snapshot) => {
      const tmp: any[] = snapshot.docs.map((doc) => ({
        id: doc.id,
        docId: doc.data().docId,
        image: doc.data().image,
        treatment: doc.data().treatment,
        description: doc.data().description,
        price: {
          before: doc.data().price?.before,
          after: doc.data().price?.after,
        },
        contact: {
          phone: doc.data().contact?.phone,
        },
        time: doc.data().time?.toDate ? doc.data().time.toDate() : new Date(doc.data().time),
      }));
      tmp.sort((a, b) => b.time - a.time);
      setCouponList(tmp);
    });

    return () => unsub();
  }, [ company.id ]);

  // 元のルーティングでは company.contract が false の場合 <Setting /> にフォール
  // バックしていた(権限処理は変更しない)。
  if (!company.contract) {
    return <Setting />;
  }

  return (
    <>
      <div className={Shared.tabHeader}>
        <div>
          <h3 className={Shared.tabHeaderTitle}>クーポン</h3>
          <p className={Shared.tabHeaderDesc}>美容学生向けの施術クーポンを発行できます。</p>
        </div>
        {couponList.length > 0 && (
          <button type="button" className={Shared.addButton} onClick={() => setMake(true)}>＋ クーポンを追加する</button>
        )}
      </div>

      {couponList.length === 0 ? (
        <div className={Shared.emptyState}>
          <div className={Shared.emptyStateIcon}><IoPricetagOutline /></div>
          <p className={Shared.emptyStateTitle}>まだクーポンが登録されていません</p>
          <p className={Shared.emptyStateDesc}>クーポンを登録すると、学生に来店のきっかけを届けられます。</p>
          <button type="button" className={Shared.addButton} onClick={() => setMake(true)}>＋ クーポンを追加する</button>
        </div>
      ) : (
        <div className={Shared.cardGrid}>
          {couponList.map((data) => (
            <CouponCard key={data.id} coupon={data} onEdit={() => setEditing(data)} />
          ))}
        </div>
      )}

      {make ? <CouponMake setMake={setMake} companyId={company.id} /> : <></> }
      {editing && <CouponMake key={editing.id} setMake={() => setEditing(null)} companyId={company.id} editing={editing} />}
    </>
  );
};

export default CouponTab;
